import { AgGridReact } from 'ag-grid-react'
import { useEffect, useState } from 'react'
import AxiosInstance from 'utils/AxiosInstance'
import moment from 'moment'
import { useSelector } from 'react-redux'
import { Card } from 'reactstrap'
import { useHistory, Link, useLocation } from 'react-router-dom'

function Orders() {
  const history = useHistory()
  const location = useLocation()

  const {
    user: { access },
  } = useSelector((store) => store.auth)
  const [rows, setRows] = useState([])

  const columns = [
    {
      headerName: 'User',
      field: 'user',
      cellRenderer: (params) => (
        <Link
          style={{ color: 'rgb(136, 137, 170)', fontWeight: 500 }}
          to={`/manager-reports/employee/${params.data.user_id}`}
        >
          {params.value}
        </Link>
      ),
    },
    {
      headerName: 'Course',
      field: 'course',
      cellRenderer: (params) => (
        <Link
          style={{ color: 'rgb(136, 137, 170)', fontWeight: 500 }}
          to={`/course/${params.data.course_id}`}
        >
          {params.value}
        </Link>
      ),
    },
    {
      headerName: 'Price',
      field: 'price',
      valueFormatter: (params) => `$${params.value.toFixed(2)}`,
    },
    { headerName: 'Date', field: 'date' },
  ]

  useEffect(() => {
    if (access !== 1 && location.pathname === '/orders') history.push('/')
  }, [access, history, location.pathname])

  useEffect(() => {
    const url =
      location?.pathname === '/orders'
        ? `/public-catalog/orders`
        : `/public-catalog/orders/mine`

    AxiosInstance.get(url).then((data) => {
      if (data && data.length) {
        const rows = data.map((item) => {
          return {
            user: `${item.first_name} ${item.last_name}`,
            user_id: item.user_id,
            course_id: item.course_id,
            course: item.name,
            price: item.price_paid,
            date: moment(item.created_at).format('D MMMM, YYYY'),
          }
        })
        setRows(rows)
      }
    })
  }, [location?.pathname])

  return (
    <Card className='mt--6 mx-3 py-4 px-3' style={{ minHeight: '85vh' }}>
      <div className='ag-theme-alpine' style={{ height: 650, width: '100%' }}>
        {location?.pathname === '/orders' ? (
          <AgGridReact columnDefs={columns} rowData={rows} />
        ) : (
          <AgGridReact columnDefs={columns?.slice(1)} rowData={rows} />
        )}
      </div>
    </Card>
  )
}

export default Orders
